import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const LOCATIONS_LOCATION_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/locations',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:Locations',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.Locations',
      },
    ]);
  };
}
